import { render, staticRenderFns } from "./idCardDialog.vue?vue&type=template&id=605b6a8c"
import script from "./idCardDialog.vue?vue&type=script&lang=js"
export * from "./idCardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports